import { Request } from "./HttpService";

import FileService from "./FileService";

function serialiaze(object) {
  let objectSerealized = "";
  let keys = Object.keys(object);
  if (keys.length > 0){
    objectSerealized = objectSerealized + "?";
  } 
  for (let key of keys) {
    if (key === "startingDate" || key === "endingDate") {
      if (object[key] || object[key] === 0){
        objectSerealized = objectSerealized + `${key}=${object[key].toISOString()}&`;
      }
    }
    else if (key === "businessAreas") {
      if (object[key].length > 0){
        objectSerealized = objectSerealized + object[key].map((item) => key + "=" + item.id).join("&") + "&";
      }
    } else {
      objectSerealized = objectSerealized + `${key}=${object[key]}&`;
    }
  }
  return objectSerealized;
}

export const HiredCandidatesService = {
  getHiredCandidates: function (pageSize, pageNumber, searchobject) {
    let url = `vitae/hiredCandidates/${pageSize}/${pageNumber}`;
    let keys = Object.keys(searchobject);
    if (keys.length > 0) url = url + "?";
    let serializedUrl = "";

    for (let key of keys) {
      if (key === "startingDate" || key === "endingDate") {
        if (searchobject[key])
          serializedUrl =
            serializedUrl + `${key}=${searchobject[key].toUTCString()}&`;
      } else if (key === "businessAreas") {
        if (searchobject[key].length > 0)
          serializedUrl =
            serializedUrl +
            searchobject[key].map((item) => key + "=" + item).join("&") +
            "&";
      } else serializedUrl = serializedUrl + `${key}=${searchobject[key]}&`;
    }

    let urlWithSearchParams =
      window.location.protocol +
      "//" +
      window.location.host +
      "/" +
      `hiredCandidates/${pageSize}/${pageNumber}?` +
      serializedUrl;
    window.history.pushState(
      { path: urlWithSearchParams },
      "",
      urlWithSearchParams
    );
    return Request(url + serializedUrl, "GET");
  },

  undoHiringCandidate(interviewId, comment) {
    return Request("vitae/hiredCandidates/undoHiring", "POST", {
      interviewId: interviewId,
      comment: comment
    });
  },

  exportToexcel(searchParameters, expectecdResults, filename, format) {
    let _searchParameters = { ...searchParameters };
    _searchParameters.expectedNumberOfResults = expectecdResults;
    _searchParameters.format = format;
    let url = "vitae/hiredCandidates" + serialiaze(_searchParameters);
    return FileService.Download(url, filename);
  }
};
